<template>
    <form class="hidden-print contact-form voucher-form"
        @submit.prevent="submit">


        <div class="form-horizontal">

            <div class="alert alert-info"
                v-show="status=='done'">
                <button type="button"
                    class="voucher-close"
                    aria-hidden="true"
                    @click="removeVoucher();">&times;</button>

                <span>{{voMsg('voucher.success',[voucher && voucher.code])}}</span>
            </div>

            <div class="alert alert-warning"
                v-show="status=='failed'">
                <span>{{voMsg('tpl.voucherfailed')}}</span>
            </div>



            <div v-show="status=='ready' || status=='failed'">

                <div class="form-group row">
                    <div class="col-sm-12">
                        <label class="d-none"
                            for="input_code_voucher">{{voMsg("tpl.text.offercode")}}</label>
                        <input type="text"
                            class="form-control voucher-input"
                            id="input_code_voucher"
                            v-model="reqCode"
                            autocomplete="off"
                            required="required">
                    </div>
                </div>
                <button type="submit"
                    class="btn btn-go w-100 mb-3">
                    {{submitLabel}}
                </button>

            </div>

            <div class="contact-sending"
                v-show="status=='submitting'"
                ng-cloak>
                <div class="spinner">
                    <div class="bounce1"></div>
                    <div class="bounce2"></div>
                    <div class="bounce3"></div>
                </div>

            </div>

            <voffice-error-message :error="error"></voffice-error-message>


        </div>
    </form>

</template>


<script>
    import V from 'voUtils/V.js'

    import {
    	doPost
    }
    from 'voUtils/RestEx.js';

    import {
    	formatMsg
    }
    from 'voUtils/voI18n.js'

    import {
    	setVoucher, getVoucher
    }
    from 'voUtils/VoucherStore.js'

    var voucher = getVoucher();

    export default {
    	voVueComponent: 'voffice-voucher-search',
    	props: {
    		voucherOkMsg: String,
    		voucherFailedMsg: String,
    		voucherCodeLabel: String,
    		submitLabel: String
    	},
    	data() {
    		return {
    			error: undefined,
    			reqCode: undefined,
    			status: voucher ? 'done' : 'ready',
    			voucher: voucher
    		}
    	},
    	methods: {
    		removeVoucher: function() {
    			localStorage.removeItem("voucher_name");
    			localStorage.removeItem("voucher_validated");
    			localStorage.removeItem("voucher_code");
    			this.status = 'ready';
    			voucher = undefined;

    			this.$parent.updateSearchResults(true);
    		},
    		submit: function() {

    			this.status = 'submitting';

    			var req = {
    				code: this.reqCode
    			};

    			voucher = undefined;

    			doPost('validateVoucher', req)
    				.then(res => {

    					if (res.voucher) {
    						res.voucher.code = req.code;

    						this.voucher = res.voucher;
    						setVoucher(this.voucher);

    						this.status = 'done';
    						this.$parent.updateSearchResults(true);


    					} else {
    						this.status = 'failed';
    					}


    				})
    				.catch(e => {
    					this.status = 'ready';
    					this.error = e;
    				})


    		}
    	}

    };
</script>
<style scoped>
    .voucher-form {
    	max-width: 600px;
    }
</style>